/**
 * @deprecated This file is deprecated. Use @starjack/utils instead.
 */

import { Moment } from 'moment';
import {
    DATE_FORMAT,
    DATE_FORMAT_BACKEND_STRING,
    DATE_TIME_FORMAT,
} from '../constants';
import { format, getDate, getMonth, getYear, isDate, isValid } from 'date-fns';
import { StarjackDate } from '@/models/general';

/**
 * @deprecated Use formatDate from @starjack/utils instead.
 */
export const formatDate = (date: Moment) => date.format(DATE_FORMAT);

/**
 * @deprecated Use formatStarjackDate from @starjack/utils instead.
 */
export const formatStarjackDate = (date: Date) => {
    if (isValid(date)) {
        return format(date, 'dd.MM.yyyy');
    }

    return null;
};

/**
 * @deprecated Use formatDateWithTime from @starjack/utils instead.
 */
export const formatDateWithTime = (date: Moment) =>
    date.format(`${DATE_TIME_FORMAT} `);

/**
 * @deprecated Use formatStarjackDateToBackendString from @starjack/utils instead.
 */
export const formatStarjackDateToBackendString = (
    date: StarjackDate
): string => {
    if (!date) return null;
    return format(date, DATE_FORMAT_BACKEND_STRING);
};

/**
 * @deprecated Use convertDateFromDateArray from @starjack/utils instead.
 */
export const convertDateFromDateArray = (dateArray: number[]) => {
    if (!Array.isArray(dateArray)) {
        return null;
    }

    const [year, month, day, hours = 0, minutes = 0] = dateArray;
    const timeZoneOffsetHours = new Date().getTimezoneOffset() / 60;

    if (hours === 0 && minutes === 0) {
        return new Date(year, month - 1, day);
    } else {
        return new Date(
            year,
            month - 1,
            day,
            hours - timeZoneOffsetHours,
            minutes
        );
    }
};

/**
 * @deprecated Use convertDateArrayFromDate from @starjack/utils instead.
 */
export const convertDateArrayFromDate = (date: Date) => {
    if (!isDate(date)) return [];

    return [getYear(date), getMonth(date) + 1, getDate(date)];
};

/**
 * @deprecated Use convertIsoDateFromDate from @starjack/utils instead.
 */
export const convertIsoDateFromDate = (date: Date) => {
    if (!isDate(date)) return '';

    return format(date, 'yyyy-MM-dd');
};

/**
 * @deprecated Use convertIsoDateToDate from @starjack/utils instead.
 */
export const convertIsoDateToDate = (isoDate: string): Date => {
    if (!isoDate) return null;

    return new Date(isoDate);
};
